import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './ui/tokens.css';
import './ui/base.css';
import './ui/ui.css';
import './app/shell.css';

import { App } from './App.js';
import { ErrorBoundary } from './app/ErrorBoundary.js';
import { AuthProvider } from './lib/auth.js';
import { ToastProvider } from './ui/index.js';

// The service worker is registered by an inline snippet the PWA plugin injects
// into index.html (injectRegister: 'inline'), so the app installs and the shell
// works offline without bundling any extra runtime here.

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root was not found');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
